<div class="flex flex-col w-full p-6 tab-frame">
    <div class="text-center mb-4">
        <div class="text-2xl text-primary"><b> {{ router.url.includes('/wrsv') ? 'Retrievable Valve / Plug' : 'TRSCSSV' }}</b></div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2  mt-2 mb-8">
        <div role="tablist" class="tabs tabs-boxed">
            <a role="tab" [ngClass]="{'primary-tab-active': !router.url.includes('/wrsv')}"
                (click)="toggleTrsssv('trscssv')" class="tab">
                TRSCSSV
            </a>
            <a role="tab" [ngClass]="{'primary-tab-active': router.url.includes('/wrsv')}"
                (click)="toggleTrsssv('wrsv')" class="tab">
                Retrievable Valve / Plug
            </a>
        </div>

        <div class="flex justify-end">
            <div class="flex items-center">
                <div [ngClass]="{'font-bold': !isReplace}">Edit</div>
                <input type="checkbox" class="toggle bg-primary mx-2" [(ngModel)]="isReplace" (change)="toggleReplace()"
                    [disabled]="disabledToggle" />
                <div [ngClass]="{'font-bold': isReplace}">Replace</div>
            </div>
        </div>
    </div>

    <router-outlet></router-outlet>
</div>

<!-- TRCSSV also known as TR-SSSV -->
<!-- Retrievable Valve / Plug also known as WRSV -->